import { render, staticRenderFns } from "./CardAccountDashboard.vue?vue&type=template&id=ed05384e&scoped=true&"
import script from "./CardAccountDashboard.vue?vue&type=script&lang=js&"
export * from "./CardAccountDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed05384e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed05384e')) {
      api.createRecord('ed05384e', component.options)
    } else {
      api.reload('ed05384e', component.options)
    }
    module.hot.accept("./CardAccountDashboard.vue?vue&type=template&id=ed05384e&scoped=true&", function () {
      api.rerender('ed05384e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/CardAccountDashboard.vue"
export default component.exports